import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { BaasI18n } from '@lvflanders/bar';

import { BaasCloseDialogButton } from '../baas-close-dialog-button/baas-close-dialog-button';
import { BAAS_CONFIRM_SETTINGS } from './baas-confirm.tokens';
import { BaasConfirmOptions, BaasConfirmSettings } from './baas-confirm.types';

@Component({
    selector: 'baas-confirm',
    templateUrl: './baas-confirm.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogModule, MatButtonModule, BaasCloseDialogButton]
})
/** Component used by the confirm service with material dialog.  */
export class BaasConfirm {
    readonly #i18n = inject(BaasI18n);
    readonly #data = inject<BaasConfirmOptions>(MAT_DIALOG_DATA);
    readonly #globalSettings = inject<BaasConfirmSettings>(BAAS_CONFIRM_SETTINGS, { optional: true });

    readonly hasTitle = this.#data.title != null;
    readonly title = this.#data.title;
    readonly message = this.#data.message;
    readonly confirmText =
        this.#data.confirmText ||
        (this.#globalSettings?.confirmText && !this.#data.ignoreGlobalSettings
            ? this.#globalSettings.confirmText
            : this.#i18n.get('DOMAIN_BAR_CONTROLS.CONFIRM.OK'));
    readonly refuteText =
        this.#data.refuteText ||
        (this.#globalSettings?.refuteText && !this.#data.ignoreGlobalSettings
            ? this.#globalSettings.refuteText
            : this.#i18n.get('DOMAIN_BAR_CONTROLS.CONFIRM.CANCEL'));

    readonly refutable = this.#data.refutable == null ? true : this.#data.refutable;
    readonly closeIcon = this.#data.closeable === 'all' || this.#data.closeable == 'iconOnly';
    readonly buttonVariant = this.#data.buttonVariant;
}
